exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "client-dashboard .page{display:flex;height:100%;flex-direction:column}client-dashboard .section-wrap{padding:20px}client-dashboard .content{position:relative;flex:1;background:#ebf2f3}client-dashboard .content .content-inner{flex:1;height:100%;padding-bottom:80px}client-dashboard .dialog-container{position:relative}client-dashboard [data-loading-order]{transition:opacity 1s}client-dashboard .lazy-loading{opacity:0}@media only screen and (max-width:779px){client-dashboard adp-header-top-bar{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/pages/clientDashboard/clientDashboard.less
// module id = 437
// module chunks = 0